import { render } from "./ComingSoon.vue?vue&type=template&id=06371d6a&scoped=true&ts=true&lang=pug"
import script from "./ComingSoon.vue?vue&type=script&lang=ts"
export * from "./ComingSoon.vue?vue&type=script&lang=ts"

import "./ComingSoon.vue?vue&type=style&index=0&id=06371d6a&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06371d6a"]])

export default __exports__